import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-navy text-ivory" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_beyond-stuck/artifacts/4bqnieq1_Company%20Logo.jpeg"
                alt="De Nicola Consulting Co."
                className="h-10 w-10 object-contain rounded-sm"
              />
              <div>
                <p className="font-lora text-ivory text-sm tracking-[0.15em] uppercase">De Nicola</p>
                <p className="text-[10px] tracking-[0.2em] uppercase text-gold/90">Consulting Co.</p>
              </div>
            </div>
            <p className="text-ivory/60 text-sm leading-relaxed font-serif">
              Strategic career advisory for advancement, pivoting, and repositioning.
            </p>
            <div className="w-10 h-px bg-gold mt-6"></div>
          </div>

          {/* Navigation */}
          <div>
            <p className="font-lora text-xs tracking-[0.2em] uppercase text-gold mb-4">Navigate</p>
            <ul className="space-y-2">
              {[
                { to: "/services", label: "Services" },
                { to: "/about", label: "About" },
                { to: "/insights", label: "Insights" },
                { to: "/contact", label: "Contact" },
                { to: "/booking", label: "Book a Session" },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-ivory/60 hover:text-gold text-sm transition-colors tracking-wide">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Philosophy */}
          <div>
            <p className="font-lora text-xs tracking-[0.2em] uppercase text-gold mb-4">Our Philosophy</p>
            <p className="text-ivory/60 text-sm leading-relaxed font-serif italic">
              "Before strategy, there must be understanding. Before movement, there must be direction."
            </p>
            <div className="mt-6">
              <Link
                to="/booking"
                className="inline-block border border-gold text-gold px-5 py-2 text-xs tracking-[0.15em] uppercase hover:bg-gold hover:text-navy transition-all duration-300"
              >
                Begin Your Journey
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-ivory/40 text-xs tracking-wide">
            &copy; {new Date().getFullYear()} De Nicola Consulting Co. All rights reserved.
          </p>
          <p className="text-ivory/30 text-xs">
            Strategic Advisory · Toronto, Canada
          </p>
        </div>
      </div>
    </footer>
  );
}
